module.exports = __webpack_public_path__ + "img/redWarning.803f8704.svg";